import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import {
  renewalRiskBadgeMeta,
  renewalRiskSourceUrl,
  renewalRiskTooltipLines,
} from '@/lib/accountRenewalRisk';

export default function AccountRenewalRiskBadge({ row }) {
  const meta = renewalRiskBadgeMeta(row?.risk_level);
  if (!meta) return null;
  const lines = renewalRiskTooltipLines(row);
  const sourceUrl = renewalRiskSourceUrl(row);

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className="inline-flex cursor-help">
            <Badge className={`text-xs px-2 py-1 border-0 ${meta.className}`}>
              {meta.text}
            </Badge>
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-xs bg-[#0A1A2F] text-white border-0 shadow-lg px-3 py-2 space-y-1.5"
        >
          {lines.map((line) => (
            <p key={line} className="text-xs leading-snug">
              {line}
            </p>
          ))}
          {sourceUrl ? (
            <a
              href={sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-xs text-[#00C2C2] hover:underline"
            >
              Source
            </a>
          ) : null}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
